import {observer} from "mobx-react";
import './onboarding-screen-title.scss';
import FontHeading1 from "../../../../components/fonts/font-heading1/font-heading1";
import {FONT_COLOR, FONT_VARIANT} from "../../../../components/fonts/font-props";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import React from "react";

interface IOnBoardingScreenTitle {
    titleText: string,
    descriptionText?: string,
    maxWidth?: number
    descriptionMaxWidth?: number
}

const OnBoardingScreenTitle: React.FC<IOnBoardingScreenTitle> = observer(({
                                                                              titleText,
                                                                              descriptionText,
                                                                              maxWidth,
                                                                              descriptionMaxWidth
                                                                          }) => {

    const descriptionLines = descriptionText?.split("\n");

    return (
        <div className="onboarding-screen-title-container">
            <div className="onboarding-screen-typo" style={{maxWidth: maxWidth}}>
                <FontHeading1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{titleText}</FontHeading1>
                {
                    descriptionText && <div style={{maxWidth: descriptionMaxWidth}}>
                        <FontBody1 color={FONT_COLOR.PRIMARY2}>
                            {
                                descriptionLines?.map((line, index) => (
                                        <React.Fragment key={index}>
                                            <span dangerouslySetInnerHTML={{__html: line}}/>
                                            {index < descriptionLines?.length - 1 && <br/>}
                                        </React.Fragment>
                                    )
                                )
                            }
                        </FontBody1>
                    </div>
                }
            </div>
        </div>
    );
});

export default OnBoardingScreenTitle;